export const HostDashboardRoute = "/host-dashboard"
export const GoogleMapsApiKey = 'AIzaSyBDM449V7qE4OkyoV2zP3xm_VQIYDvrHVw'
